export const getUserBillingMethodsEndpoint = billingId => `User/Billing/${billingId}/Method`;
export const getUserBillingMethodChangeEndpoint = methodId => `User/Billing/Method/${methodId}:change`;
